(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {

    var HeliumValidation = {

      $trigger: null,
      active: 1,
      busy: 0,
      errors: [],
      ignore: 0,
      valid: true,

      listeners: {
        '#save-post': [{
          ev: 'click',
          func: 'clickIgnore'
        }],
        '[type="submit"]': [{
          ev: 'click',
          func: 'clickPublish'
        }],
        '#post': [{
          ev: 'submit',
          func: 'submitForm'
        }]
      },

      /*
      ==========================================================================
      click ignore
      ==========================================================================
      */
      clickIgnore: function clickIgnore(e) {
        // reference
        var self = this,
            $this = $(e.currentTarget);

        // vars
        this.ignore = 1;
        this.$trigger = $this;
        this.$form = $this.closest('form');

        // ignore required inputs
        this.ignoreRequired();

        // maybe show errors
        setTimeout(function () {
          self.ignore = 0;
        }, 100);
      },

      /*
      ==========================================================================
      ignore required
      ==========================================================================
      */
      ignoreRequired: function ignoreRequired() {
        // vars
        var $inputs = $('.typerocket-container [required]');

        // bail early if no inputs
        if (!$inputs.length) return;

        // remove required
        $inputs.prop('required', false);

        // timeout
        setTimeout(function () {
          $inputs.prop('required', true);
        }, 100);
      },

      /*
      ==========================================================================
      click publish
      ==========================================================================
      */
      clickPublish: function clickPublish(e) {
        this.$trigger = $(e.currentTarget);
      },

      /*
      ==========================================================================
      submit form
      ==========================================================================
      */
      submitForm: function submitForm(e) {
        if (!this.active) return true;

        // ignore validation (only ignore once)
        if (this.ignore) {
          this.ignore = 0;
          return true;
        }

        // bail early if is preview
        var $this = $(e.currentTarget),
            $preview = $this.find('#wp-preview');

        if ($preview.exists() && $preview.val()) {
          // WP will lock form, unlock it
          this.toggle($this, 'unlock');
          return true;
        }

        e.preventDefault();
        this.validate($this);
      },

      /*
      ==========================================================================
      validate
      ==========================================================================
      */
      validate: function validate($form) {
        // bail early if already busy
        if (this.busy) return false;

        var self = this,
            data = $form.find('input, select, textarea').not('[name="_wpnonce"]').serializeArray();

        // set busy
        this.busy = 1;

        // lock form
        this.toggle($form, 'lock');

        // ajax
        $.ajax({
          url: '/wp-json/he/validate',
          data: data,
          type: 'post',
          dataType: 'json',
          // beforeSend: function(xhr) {
          //   xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce)
          // },
          success: function success(json) {
            self.validateSuccess($form, json);
          },
          complete: function complete() {
            self.validateComplete($form);
          }
        });
      },

      /*
      ==========================================================================
      fetch complete
      ==========================================================================
      */
      validateComplete: function validateComplete($form) {

        // set busy
        this.busy = 0;

        // unlock so WP can publish form
        this.toggle($form, 'unlock');

        // bail early if validation was not valid
        if (!this.valid) return;

        // update ignore (allow form submit to not run validation)
        this.ignore = 1;

        // remove previous error message
        var $message = $('.he-error');

        if ($message.exists()) {

          $message.removeClass('notice-error').addClass('notice-success');
          $message.html('<p>Validation successful!</p>');

          // remove message
          setTimeout(function () {
            $message.remove();
          }, 2000);
        }

        // submit form again
        if (this.$trigger) {
          this.$trigger.click();
        } else {
          $form.submit();
        }

        // lock form
        this.toggle($form, 'lock');
      },

      /*
      ==========================================================================
      fetch success
      ==========================================================================
      */
      validateSuccess: function validateSuccess($form, json) {

        // validate json
        if (!Object.keys(json).length) {

          // set valid (allows validateComplete to run)
          this.valid = true;

          return;
        }

        // set valid (prevents validateComplete from running)
        this.valid = false;

        // reset trigger
        this.$trigger = null;

        // display errors
        this.displayErrors(json);
      },

      displayErrors: function displayErrors(errors) {
        var $errors = $('<div class="notice notice-error is-dismissible he-error">\n          <ul></ul>\n          <button type="button" class="notice-dismiss"><span class="screen-reader-text">Dismiss this notice.</span></button>\n        </div>');
        $('.wp-header-end').after($errors);
        for (var key in errors) {
          $errors.find('ul').append('<li>' + errors[key] + '</li>');
        }

        // hack to make dynamic notice dismissible
        // button in the markup above is a hack too
        $errors.on('click.wp-dismiss-notice', function (e) {
          e.preventDefault();
          $(this).fadeTo(100, 0, function () {
            $(this).slideUp(100, function () {
              $(this).remove();
            });
          });
        });
      },

      /*
      ==========================================================================
      utilities
      ==========================================================================
      */
      showSpinner: function showSpinner($spinner) {
        if (!$spinner.exists()) return;
        $spinner.addClass('is-active');
      },

      hideSpinner: function hideSpinner($spinner) {
        if (!$spinner.exists()) return;
        $spinner.removeClass('is-active');
      },

      disableSubmit: function disableSubmit($submit) {
        if (!$submit.exists()) return;
        $submit.addClass('disabled button-disabled button-primary-disabled');
      },

      enableSubmit: function enableSubmit($submit) {
        if (!$submit.exists()) return;
        $submit.removeClass('disabled button-disabled button-primary-disabled');
      },

      /*
      ==========================================================================
      toggle state
      ==========================================================================
      */
      toggle: function toggle($form, state) {

        // defaults
        state = state || 'unlock';

        // debug
        //console.log('toggle %o, %o %o', this.$trigger, $form, state)

        // vars
        var $submit = null,
            $spinner = null,
            $parent = $('#submitdiv');

        // 3rd party publish box
        if (!$parent.exists()) $parent = $('#submitpost');

        // term, user
        if (!$parent.exists()) $parent = $form.find('p.submit').last();

        // default
        if (!$parent.exists()) $parent = $form;

        // find elements
        // note: media edit page does not use .button, this is why we need to look for generic input[type="submit"]
        $submit = $parent.find('input[type="submit"], .button');
        $spinner = $parent.find('.spinner');

        // hide all spinners (hides the preview spinner)
        this.hideSpinner($spinner);

        // unlock
        if (state == 'unlock') {

          this.enableSubmit($submit);

          // lock
        } else if (state == 'lock') {

          // show only last spinner (allow all spinners to be hidden - preview spinner + submit spinner)
          this.disableSubmit($submit);
          this.showSpinner($spinner.last());
        }
      },

      /*
      ==========================================================================
      listeners
      ==========================================================================
      */
      addListeners: function addListeners() {
        for (var selector in this.listeners) {
          this.addListener(selector, this.listeners[selector]);
        }
      },

      addListener: function addListener(selector, listener) {
        if (listener instanceof Array) {
          for (var item in listener) {
            this.addListener(selector, listener[item]);
          }
        } else {
          $(selector).on(listener.ev, this[listener.func].bind(this));
        }
      },

      /*
      ==========================================================================
      init
      ==========================================================================
      */
      init: function init() {
        this.addListeners();
      }

    };

    HeliumValidation.init();

    /*
    ==========================================================================
    helpers
    ==========================================================================
    */
    $.fn.exists = function () {
      return $(this).length > 0;
    };
  });
});

},{}]},{},[1]);
